<!--
  TagsFilter renders a filter with dropdown tag options and reads/writes
  from the `tags` URL query param. Possible tag values are populated from the
  store.
-->

<script>
import { mapState } from 'vuex';
import { iFilter } from '@inscribe/signal';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

export default {
  components: {
    iFilter,
  },
  props: {
    analyticsLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    ...mapState(['tags']),
    tagOptions() {
      return this.tags.list.map((t) => ({ label: t.value }));
    },
    value() {
      const { tags } = this.params;
      if (!tags) {
        return [];
      }
      if (typeof tags === 'string') {
        return [tags];
      }
      return tags;
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(updated) {
      const updatedValues = updated.selection.map((t) => t.label);
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          tags:
            updatedValues.length === 0 ? undefined : updatedValues.join(','),
        },
      });
    },
  },
};
</script>

<template>
  <iFilter
    label="Tags"
    data-testid="tags-filter"
    :data-dd-action-name="analyticsLabel"
    :options="tagOptions"
    :value="value"
    @selection-changed="onSelectionChanged"
  />
</template>
